import { CheckSquare } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'checkboxgroup',
  renderInput: ({ field, value, onChange }) => {
    const options = field.options ?? [];
    const selected = Array.isArray(value) ? (value as string[]) : [];

    const toggle = (v: string) => {
      onChange(selected.includes(v) ? selected.filter((s) => s !== v) : [...selected, v]);
    };

    return (
      <div className="space-y-2">
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex cursor-pointer items-center gap-3 rounded-lg border border-border-primary p-3 transition-colors hover:bg-bg-secondary"
          >
            <input
              type="checkbox"
              checked={selected.includes(opt.value)}
              onChange={() => toggle(opt.value)}
              className="h-4 w-4 rounded accent-accent-600"
            />
            <div className="flex flex-1 items-center gap-2">
              {opt.color && (
                <span
                  className="h-3 w-3 flex-shrink-0 rounded-full"
                  style={{ backgroundColor: opt.color }}
                />
              )}
              <span className="text-sm text-text-primary">{opt.label}</span>
            </div>
          </label>
        ))}
        {options.length === 0 && (
          <p className="text-sm text-text-muted">Brak zdefiniowanych opcji</p>
        )}
      </div>
    );
  },
  renderCell: (field, value) => {
    if (!Array.isArray(value) || value.length === 0) return '—';
    const vals = value as string[];
    const opts = (field.options ?? []).filter((o) => vals.includes(o.value));
    const shown = opts.slice(0, 2);
    const rest = opts.length - 2;
    return (
      <div className="flex items-center gap-1 flex-wrap">
        <CheckSquare className="h-3.5 w-3.5 flex-shrink-0 text-accent-600" />
        {shown.map((o) => (
          <span
            key={o.value}
            className="rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700"
          >
            {o.label}
          </span>
        ))}
        {rest > 0 && <span className="text-xs text-text-tertiary">+{rest}</span>}
      </div>
    );
  },
  validate: (value, field) => {
    if (!Array.isArray(value)) return 'Wartość musi być tablicą';
    const valid = (field.options ?? []).map((o) => o.value);
    const bad = (value as string[]).filter((v) => !valid.includes(v));
    if (bad.length > 0) return `Nieprawidłowe wartości: ${bad.join(', ')}`;
    const rules = (field.validationRules ?? {}) as Record<string, unknown>;
    if (rules['minLength'] && value.length < Number(rules['minLength']))
      return `Wybierz minimum ${rules['minLength']} opcji`;
    if (rules['maxLength'] && value.length > Number(rules['maxLength']))
      return `Wybierz maksimum ${rules['maxLength']} opcji`;
    return null;
  },
  defaultValue: [],
});
